module.exports = __webpack_public_path__ + "static/media/top-header-big.49e0cff0.png";